import { PalstatDefaultButtonsProps } from "../../types/palstatDefaultButtonsProps";
import BottomButtonTemplate from "../common/BottomButtonTemplate";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { translateString } from "../../translations/gridTranslationHelper";

export default function PalstatDefaultBottomButtons(props: PalstatDefaultButtonsProps) {
    const aplSettings = AplSettingsSelector();
    const { t } = useTranslation();
    return (
        <div
            id="div-bottom-buttons"
            className="row float-right btn-group margin-right-0 buttoms-shift-up"
            role="group"
            aria-label="Bottom action buttons"
        >
            <BottomButtonTemplate
                text={t("main.palletDetail")}
                enabled={props.options.palletDetails}
                func={props.options.palletDetailsClick}
            />
            <BottomButtonTemplate text={t("main.block")} enabled={props.options.block} func={props.options.blockClick} />
            <BottomButtonTemplate text={t("main.unblock")} enabled={props.options.unblock} func={props.options.unblockClick} />
            <BottomButtonTemplate text={t("main.reprint")} enabled={props.options.reprint} func={props.options.reprintClick} />
            {props.options.hideScrap ? (
                ""
            ) : (
                <BottomButtonTemplate text={t("main.scrap")} enabled={props.options.scrap} func={props.options.scrapClick} />
            )}
            <BottomButtonTemplate text={t("main.delete")} enabled={props.options.delete} func={props.options.deleteClick} />
            {!props.options.hidePartPallet && (
                <BottomButtonTemplate text={t("main.partPallet")} enabled={props.options.partPallet} func={props.options.partPalletClick} />
            )}

            <BottomButtonTemplate text={t("main.copySscc")} enabled={props.options.copySscc} func={props.options.copySsccClick} />

            <Tooltip id={`bob-tooltip-reset`} html={`<div>${translateString("resetView", aplSettings.culture)}</div>`} />
            <button
                type="button"
                className="btn btn-secondary active"
                onClick={props.options.resetViewClick}
                data-tooltip-delay-hide={333}
                data-tooltip-id={`bob-tooltip-reset`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-x-circle" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </button>
        </div>
    );
}
